import firebase from "firebase";
//import Vue from "vue";

import { Dispatcher } from "@/store/helper/firestore";
import _ from "lodash";

export const api = {
  namespace: "standards",
  actions: {
    loadStandards: "loadStandards",
    importStandards: "importStandards",
    createStandard: "createStandard"
  },
  mutations: {
    resetState: "resetState",
    setloadedStandards: "setloadedStandards",
    createStandard: "createStandard"
  },
  getters: {
    loadedStandards: "loadedStandards",
    getStandard: "getStandard",
    getStandardList: "getStandardList"
  },
  state: {
    loadedStandards: "loadedStandards"
  }
};

const defaultState = () => {
  return {
    [api.state.loadedStandards]: {}
  };
};

const state = defaultState();

const actions = {
  async [api.actions.loadStandards]({ commit, dispatch }) {
    dispatch("app/setLoading", false, { root: true });
    firebase
      .firestore()
      .collection("standards")
      .get()
      .then(snapshot => {
        let standards = {};
        snapshot.forEach(doc => {
          const standard = doc.data();
          const key = doc.id;
          standards[key] = { ...standard, id: key };
        });
        console.log("Fetch data from firebase", standards);
        commit("setloadedStandards", standards);
        dispatch("app/setLoading", false, { root: true });
      })
      .catch(err => {
        console.error(err);
        dispatch(
          "app/addStatus",
          {
            message: err.message,
            type: "error"
          },
          { root: true }
        );
        dispatch("app/setLoading", false, { root: true });
      });
  },
  async [api.actions.importStandards]({ commit }, payload) {
    const ref = "standards";
    const mutation = "createStandard";
    const child = "";
    const doc = payload.data.id;

    console.log("Payload", payload);

    return Dispatcher.createAsync({
      ref,
      child,
      payload,
      commit,
      mutation,
      doc
    });
  }
};

const mutations = {
  [api.mutations.resetState](state) {
    Object.assign(state, defaultState());
  },
  [api.mutations.setloadedStandards](state, payload) {
    // TODO: Wir müssen uns überlegen, ob wir über die App den Standard ausliefern wollen, oder ob wir das über die DB machen?!
    state.loadedStandards = { ...defaultState().loadedStandards, ...payload };
  },
  [api.mutations.createStandard](state, payload) {
    console.log("createStandard", state, payload);
    const standard_id = payload.item_id;
    state.loadedStandards[standard_id] = { ...payload.data, id: standard_id };
  }
};

const getters = {
  [api.getters.loadedStandards](state) {
    return state.loadedStandards;
  },
  [api.getters.getStandardList](state) {
    return _.map(state.loadedStandards, (value, key) => {
      return { id: key, name: value.name, description: value.description };
    });
  },
  [api.getters.getStandard](state) {
    return objectId => {
      if (state.loadedStandards[objectId]) {
        console.debug("Load Standard");

        let result = state.loadedStandards[objectId];

        //Object.keys(result).map(v => v.standard = objectId)

        return result;
      } else {
        console.debug("Loading default standard");

        let result = state.loadedStandards["iso9001"];

        //Object.keys(result).map(v => v.standard = "iso9001")

        return result;
      }
    };
  }
};

export default {
  namespaced: true,
  api,
  state,
  actions,
  mutations,
  getters
};
